<template>
  <el-card>
    <div slot="header" class="flex">Logout Taxi</div>
    <el-form class="config-card__body" label-position="top" size="mini">
      <div class="flex">
        <el-form>
          <WorkgroupSelector v-model="workgroupId" />
          <el-form-item label="Taxi">
            <SingleSelect
              v-model="taxiId"
              :items="wgTaxis"
              item-description="central"
              clearable
              item-label="license"
              item-value="id"
            />
          </el-form-item>
          <el-button size="mini" style="margin-top: 20px" type="primary" @click="logoutTaxi">
            Logout
          </el-button>
        </el-form>
      </div>
    </el-form>
  </el-card>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { ejectTaxi, getTaxisByWorkgroup } from "@/api/operations/taxis";
import SingleSelect from "@/components/common/forms/SingleSelect.vue";
import { useStore } from "@/utils/useStore";
import { useMessage } from "@/utils/useMessage";
import WorkgroupSelector from "@/components/common/forms/WorkgroupSelector.vue";

const store = useStore();
const message = useMessage();

const taxiId = ref<number>();

const workgroupId = ref<number>(store.getters["app/selectedWorkgroupsIds"][0]);

const wgTaxis = ref<{ license: string; id: number; idCentral: number }[]>([]);

const fetchTaxis = async () => {
  wgTaxis.value = ((await getTaxisByWorkgroup(workgroupId.value)) || []).filter(
    (t: { deleted: number }) => !t.deleted
  );
};

watch(workgroupId, () => {
  fetchTaxis();
});

onMounted(() => {
  fetchTaxis();
});

const logoutTaxi = async () => {
  const taxi = wgTaxis.value.find((t) => t.id === taxiId.value);
  if (!taxi) {
    return;
  }
  await ejectTaxi(taxi.idWorkgroup, taxi.idCentral, taxi.id);
  message({
    type: "success",
    message: `Se ha cerrado la app para el taxi: ${taxi.license}`,
  });
};
</script>
